import { AuthLayout } from '../components/AuthLayout';
import AccountConfirmContent from './AccountConfirmContent';

const AccountConfirm = () => (
  <AuthLayout>
    <AccountConfirmContent />
  </AuthLayout>
);

export default AccountConfirm;
